import React from "react";
import ReactDOM from "react-dom";
import { Router, Route } from "react-router-dom";
import { createBrowserHistory } from 'history';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
// import { Buffer } from 'buffer';
import { oktaAuth } from "oktaConfig";
import App from "./App";
import "./index.css";

// window.Buffer = window.Buffer || Buffer; Used for autodesk viewer Release 2
const customHistory = createBrowserHistory();

ReactDOM.render(
  <Router history={customHistory}>
    <Security 
      oktaAuth={oktaAuth} 
      restoreOriginalUri={async (_oktaAuth, originalUri) => {
        customHistory.replace(toRelativeUrl(originalUri || '/', window.location.origin));
      }}
    >
      <App />
    </Security>
  </Router>,
  document.getElementById("root")
);